import React, { useEffect, useState } from "react";
import axios from "axios";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { FaFilePdf } from "react-icons/fa";
import "@fontsource/chivo";

const ITEMS_PER_PAGE = 10;

const AbbonamentiTable = () => {
  const [abbonamenti, setAbbonamenti] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [filterNome, setFilterNome] = useState("");
  const [filterCognome, setFilterCognome] = useState("");
  const [filterEmail, setFilterEmail] = useState("");
  const [filterDate, setFilterDate] = useState("");

  useEffect(() => {
    axios
      .get("https://api.lidodavittorio.it/api/abbonamenti")
      .then((res) => {
        setAbbonamenti(res.data);
        setFiltered(res.data);
      })
      .catch((err) => console.error("Errore caricamento abbonamenti:", err));
  }, []);

  useEffect(() => {
    let data = [...abbonamenti];
    if (filterNome.trim()) {
      data = data.filter((a) => a.nome.toLowerCase().includes(filterNome.toLowerCase()));
    }
    if (filterCognome.trim()) {
      data = data.filter((a) => a.cognome.toLowerCase().includes(filterCognome.toLowerCase()));
    }
    if (filterEmail.trim()) {
      data = data.filter((a) => a.email.toLowerCase().includes(filterEmail.toLowerCase()));
    }
    if (filterDate) {
      data = data.filter((a) => a.created_at.startsWith(filterDate));
    }
    setFiltered(data);
    setCurrentPage(1);
  }, [filterNome, filterCognome, filterEmail, filterDate, abbonamenti]);

  const totalPages = Math.ceil(filtered.length / ITEMS_PER_PAGE);
  const paginated = filtered.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const exportToPDF = () => {
    const doc = new jsPDF();
    doc.text("Elenco Abbonamenti", 14, 15);
    const rows = filtered.map((a) => [
      a.titolo,
      a.prezzo,
      a.nome,
      a.cognome,
      a.email,
      a.phone,
      a.created_at,
    ]);
    autoTable(doc, {
      startY: 20,
      head: [["Titolo", "Prezzo", "Nome", "Cognome", "Email", "Telefono", "Creato"]],
      body: rows,
      styles: { fontSize: 9 },
      headStyles: { fillColor: [0, 159, 183] },
    });
    doc.save("abbonamenti.pdf");
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };

  return (
    <div className="overflow-x-auto font-[chivo]">
      <h2 className="text-2xl font-bold text-[#009FB7] mb-6">Riepilogo Abbonamenti</h2>

      <div className="mb-4 flex flex-wrap gap-4">
        <input
          type="text"
          placeholder="Filtra per Nome..."
          value={filterNome}
          onChange={(e) => setFilterNome(e.target.value)}
          className="border px-3 py-2 rounded"
        />
        <input
          type="text"
          placeholder="Filtra per Cognome..."
          value={filterCognome}
          onChange={(e) => setFilterCognome(e.target.value)}
          className="border px-3 py-2 rounded"
        />
        <input
          type="text"
          placeholder="Filtra per Email..."
          value={filterEmail}
          onChange={(e) => setFilterEmail(e.target.value)}
          className="border px-3 py-2 rounded"
        />
        <input
          type="date"
          value={filterDate}
          onChange={(e) => setFilterDate(e.target.value)}
          className="border px-3 py-2 rounded"
        />
        <button
          onClick={exportToPDF}
          className="bg-[#009FB7] text-white px-4 py-2 rounded hover:bg-[#007d99] flex items-center gap-2"
        >
          <FaFilePdf className="text-lg text-red-200" /> Esporta PDF
        </button>
      </div>

      <table className="w-full border-collapse text-sm">
        <thead className="bg-[#009FB7] text-white">
          <tr>
            <th className="p-2 border">Titolo</th>
            <th className="p-2 border">Prezzo</th>
            <th className="p-2 border">Nome</th>
            <th className="p-2 border">Cognome</th>
            <th className="p-2 border">Email</th>
            <th className="p-2 border">Telefono</th>
            <th className="p-2 border">Creato</th>
          </tr>
        </thead>
        <tbody>
          {paginated.map((a) => (
            <tr key={a.session_id || a.email + a.titolo} className="hover:bg-gray-100">
              <td className="p-2 border">{a.titolo}</td>
              <td className="p-2 border text-[#009FB7] font-bold">
                €{a.prezzo.toFixed(2)}
              </td>
              <td className="p-2 border">{a.nome}</td>
              <td className="p-2 border">{a.cognome}</td>
              <td className="p-2 border">{a.email}</td>
              <td className="p-2 border">{a.phone}</td>
              <td className="p-2 border">
                {new Date(a.created_at).toLocaleString("it-IT", {
                  timeZone: "Europe/Rome",
                })}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="flex justify-center items-center gap-4 mt-6">
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50"
        >
          ◀ Precedente
        </button>
        <span>
          Pagina <strong>{currentPage}</strong> di <strong>{totalPages}</strong>
        </span>
        <button
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50"
        >
          Prossimo ▶
        </button>
      </div>
    </div>
  );
};

export default AbbonamentiTable;
